// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3hnK_","label":"LabeledBox_label__3A_6Z"};